import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportDeltaLinkedFetch } from './actions';

export const sagasReportDeltaLinked = [
  takeLatest(actionReportDeltaLinkedFetch.rejected, workerErrorNotifyThunk),
];
